import request from '@/util/request';

export const getList = (current, size, params) => {
  return request({
    url: '/api/v4ward/car/ParkSpace/page/v2',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    },
  });
};
export const remove = (ids) => {
  return request({
    url: '/api/v4ward/car/ParkSpace/remove/v2',
    method: 'post',
    params: {
      ids,
    },
  });
};

export const add = (row) => {
  return request({
    url: '/api/v4ward/car/ParkSpace/save/v2',
    method: 'post',
    data: row,
  });
};

export const syncData = (param) => {
  return request({
    url: '/api/v4ward/car/ParkSpace/sync/v2',
    method: 'post',
    data: param,
  });
};
export const update = (row) => {
  return request({
    url: '/api/v4ward/car/ParkSpace/submit/v2',
    method: 'post',
    data: row,
  });
};

export const getDetail = (id) => {
  return request({
    url: '/api/v4ward/car/ParkSpace/list/v2',
    method: 'get',
    params: {
      id,
    },
  });
};
export const getSpaceTree = (tenantId) => {
  return request({
    url: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',
    method: 'get',
    params: {
      tenantId,
    },
  });
};

//获取区域
export const loadRegionByParentId = (parentId) => {
  return request({
    url: '/api/v4ward/car/parkSpaceNode/nodeTreeByParentId/v2',
    method: 'get',
    params: {
      parentId,
    },
  });
};
